import React, { useState, useEffect, useContext } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable, { Alignment } from "react-data-table-component";
import { createTheme } from "react-data-table-component";
import { FaEdit, FaTrash, FaEye, FaBorderAll } from "react-icons/fa";
import { TfiMenuAlt, } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/DealerProfile.jsx";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import useSWR, { mutate } from "swr";
import { Bell, Cake, X, PhoneCall } from 'lucide-react'
import { useLocation } from "react-router-dom";
// import { Pagination } from "flowbite-react";
import { AllStates } from "../context/globalState.jsx";


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    return (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-4 mr-[45px]">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>


            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};


createTheme(
    "solarized",
    {
        text: {
            primary: "#268bd2",
            secondary: "#2aa198",
        },
        background: {
            default: "#002b36",
        },
        context: {
            background: "#cb4b16",
            text: "#FFFFFF",
        },
        divider: {
            default: "#073642",
        },
        action: {
            button: "rgba(0,0,0,.54)",
            hover: "rgba(0,0,0,.08)",
            disabled: "rgba(0,0,0,.12)",
        },
    },
    "dark" // optional: dark or light
);





export default function ContactsTable() {
    const { dealerDetail } = useUserContext();
    // console.log({dealerDetail});
    const { allState, allStatedispatch } = useContext(AllStates);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const navigate = useNavigate();
    // const [isLoading, setIsLoading] = useState(true);
    // const [leads, setLeads] = useState([]);
    const [lead, setLead] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alternatePhoneError, setAlternatePhoneError] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
    const [searchTerm, setSearchTerm] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);




    // When initializing
    const [searchValues, setSearchValues] = useState(() => {
        const saved = JSON.parse(localStorage.getItem("Leadspagination")) || {};
        return {
            limit: saved.limit || 25,
            page: saved.page || 1,
        };
    });

    // When updating
    useEffect(() => {
        localStorage.setItem("Leadspagination", JSON.stringify(searchValues));
    }, [searchValues]);



    const [selectedRow, setSelectedRow] = useState(null); // Optional


    // const [leadSourceOptions, setLeadSourceOptions] = useState([]);

    // Lead Source & Call Disposition Field IDs
    const leadSourceFieldId = "362892000776215547";
    const callDispositionFieldId = "6928350000002235290"; // <-- replace with actual ID
    const leadStatusFieldId = "6928350000000603887";

    // State for both picklists
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [callDispositionOptions, setCallDispositionOptions] = useState([]);
    const [leadStatusOptions, setLeadStatusOptions] = useState([]);



    // Values we want to exclude (only for Lead Sources)
    const notAllowedLeadSources = [
        "-None-",
        "HNI and UHNI",
        "MVD",
        "Standard Donors and Major Retention",
        "Acquisitions"
    ];

    // SWR fetcher
    const fetcher = url => fetch(url).then(res => res.json());

    // Endpoints for both picklists
    const leadSourceEndpoint = `/server/dealer_backend/getPickListValues/${leadSourceFieldId}?module=Leads&type=used`;
    const callDispositionEndpoint = `/server/dealer_backend/getPickListValues/${callDispositionFieldId}?module=Leads&type=used`;
    const leadStatusEndpoint = `/server/dealer_backend/getPickListValues/${leadStatusFieldId}?module=Leads&type=used`;
    // const donationPurposeEndpoint = `/server/dealer_backend/getPickListValues/760958000004617209?module=Leads&type=used`;

    // Fetch both via SWR
    const swrOptions = {
        revalidateOnFocus: false,     // don't refetch when window gains focus
        revalidateOnReconnect: false, // don't refetch on network reconnect
        revalidateIfStale: false,     // don't refetch if cache is stale
        shouldRetryOnError: false,    // optional: don't retry on error
    };

    const { data: leadSourceResult, error: leadSourceError } = useSWR(
        leadSourceEndpoint,
        fetcher,
        swrOptions
    );

    const { data: callDispositionResult, error: callDispositionError } = useSWR(
        callDispositionEndpoint,
        fetcher,
        swrOptions
    );

    const { data: leadStatusResult, error: leadStatusError } = useSWR(
        leadStatusEndpoint,
        fetcher,
        swrOptions
    );



    // Lead Source picklist effect
    useEffect(() => {
        if (!leadSourceResult) return;

        if (leadSourceResult.status === "success") {
            const filtered = (leadSourceResult.data || []).filter(
                (opt) => !notAllowedLeadSources.includes(opt.value || opt)
            );
            setLeadSourceOptions(filtered);

            const key = `picklist-${leadSourceFieldId}`;
            allStatedispatch({
                type: "add",
                payload: { [key]: filtered },
            });
        } else {
            console.error("Failed to fetch lead source picklist:", leadSourceResult.error);
        }

        if (leadSourceError) {
            console.error("Error fetching lead source picklist:", leadSourceError);
        }
    }, [leadSourceResult, leadSourceError]);

    useEffect(() => {
        if (!leadStatusResult) return;

        if (leadStatusResult.status === "success") {
            const filtered = (leadStatusResult.data || []).filter(
                (opt) => !notAllowedLeadSources.includes(opt.value || opt)
            );
            setLeadStatusOptions(leadStatusResult.data);

            const key = `picklist-${leadStatusFieldId}`;
            allStatedispatch({
                type: "add",
                payload: { [key]: filtered },
            });
        } else {
            console.error("Failed to fetch lead source picklist:", leadStatusResult.error);
        }

        if (leadStatusError) {
            console.error("Error fetching lead source picklist:", leadStatusError);
        }
    }, [leadStatusResult, leadStatusError]);

    // Call Disposition picklist effect
    useEffect(() => {
        if (!callDispositionResult) return;

        if (callDispositionResult.status === "success") {
            setCallDispositionOptions(callDispositionResult.data || []);

            const key = `picklist-${callDispositionFieldId}`;
            allStatedispatch({
                type: "add",
                payload: { [key]: callDispositionResult.data || [] },
            });
        } else {
            console.error("Failed to fetch call disposition picklist:", callDispositionResult.error);
        }

        if (callDispositionError) {
            console.error("Error fetching call disposition picklist:", callDispositionError);
        }
    }, [callDispositionResult, callDispositionError]);


    const fetchPicklistOptions = async (fieldId, setOptions) => {
        try {
            const res = await fetch(
                `/server/dealer_backend/getPickListValues/${fieldId}?module=Leads&type=used`
            );
            const result = await res.json();
            if (result.status === "success") {
                // console.log({ fieldId, result });
                setOptions(result.data || []);
                const key = `picklist-${fieldId}`
                allStatedispatch({
                    type: "add",
                    payload: { [key]: result?.data },
                })

            } else {
                console.error("Failed to fetch picklist:", result.error);
            }
        } catch (err) {
            console.error("Error fetching picklist:", err);
        }
    };

    useEffect(() => {

        const picklistMap = [
            { key: 'picklist-760958000004617209', action: () => fetchPicklistOptions("760958000004617209", setDonationOptions), onData: setDonationOptions },

        ]

        picklistMap.forEach(ob => {
            if (!allState[ob?.key]) {
                // console.log("fetching : ", ob.key)
                ob.action();
            } else {
                ob.onData(allState[ob?.key]);
            }
        })

        // console.log("---- PICKLIST ----")
        // console.log(allState['picklist-760958000001085586'])
        // console.log(allState['picklist-760958000004566661'])
        // console.log(allState['picklist-760958000004425144'])
        // console.log(allState)
        // fetchPicklistOptions("760958000000407488", setLeadSourceOptions); // IFR Lead Source
    }, []);



    // -------- all state function 


    // const fetchPicklistOptions = async (fieldId, setOptions) => {
    //     try {
    //         const res = await fetch(
    //             `/server/dealer_backend/getPickListValues/${fieldId}?module=Contacts&type=used`
    //         );
    //         const result = await res.json();
    //         if (result.status === "success") {

    //             setOptions(result.data || []);
    //             const key = `picklist-${fieldId}`
    //             allStatedispatch({
    //                 type: "add",
    //                 payload: { [key]: result?.data },
    //             })

    //         } else {
    //             console.error("Failed to fetch picklist:", result.error);
    //         }
    //     } catch (err) {
    //         console.error("Error fetching picklist:", err);
    //     }
    // };

    // useEffect(() => {

    //     const picklistMap = [
    //         { key: 'picklist-760958000001085586', action: () => fetchPicklistOptions("760958000001085586", setDonationOptions), onData: setDonationOptions },
    //         { key: 'picklist-760958000004566661', action: () => fetchPicklistOptions("760958000004566661", setContactPreferencesOptions), onData: setContactPreferencesOptions },
    //         { key: 'picklist-760958000004425144', action: () => fetchPicklistOptions("760958000004425144", setCallDispositionOptions), onData: setCallDispositionOptions },
    //     ]

    //     // if(!allState['picklist-760958000001085586']){
    //     //     fetchPicklistOptions("760958000001085586", setDonationOptions);        // Donation Purpose
    //     // }else{
    //     //     setDonationOptions(allState['picklist-760958000001085586'])
    //     // }
    //     // if(!allState['picklist-760958000004566661']){
    //     //     fetchPicklistOptions("760958000004566661", setContactPreferencesOptions); // Contact Preferences
    //     // }
    //     // if(!allState['picklist-760958000004425144']){
    //     //     fetchPicklistOptions("760958000004425144", setCallDispositionOptions);   // Call Dispositions
    //     // }

    //     picklistMap.forEach(ob => {
    //         if (!allState[ob?.key]) {
    //             console.log("fetching : ", ob.key)
    //             ob.action();
    //         } else {
    //             ob.onData(allState[ob?.key]);
    //         }
    //     })

    //     console.log("---- PICKLIST ----")
    //     console.log(allState['picklist-760958000001085586'])
    //     console.log(allState['picklist-760958000004566661'])
    //     console.log(allState['picklist-760958000004425144'])
    //     console.log(allState)
    //     // fetchPicklistOptions("760958000000407488", setLeadSourceOptions); // IFR Lead Source
    // }, []);

    // const [totalRecords, setTotalRecords] = useState(0);
    const [filteredLead, setFilteredLead] = useState([]);

    const openModal = () => {
        setPrevSelectedColumns(selectedColumns); // Save current state before changes
        setIsModalOpen(true);
    };
    const columns = [
        {
            name: "S.No",
            selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
            sortable: false,
            width: "80px",
            center: true,
        },
        {
            name: "Ticket Name",
            selector: row => `${row.Ticket_id || ""}`,
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/ticket-details/${row.id}`)}
                >
                    {`${row?.Customer_ID || ""}-${row?.Customer_Code.name}`}
                </span>
            ),
            sortable: true,
            filterable: true,
            wrap: true,
            minWidth: "500px",
            style: { fontSize: 16, color: "#5A5A5C" },
        },
        {
            name: "Ticket Id",
            selector: row => `${row.Ticket_id || ""}`,
            cell: row => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => navigate(`/ticket-details/${row.id}`)}
                >
                    {`${row.Ticket_id || ""}`}
                </span>
            ),
            sortable: true,
            filterable: true,
            wrap: true,
            minWidth: "300px",
            style: { fontSize: 16, color: "#5A5A5C" },
        },
        { name: "Status Of Ticket", selector: row => row.Status_of_Ticket, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        { name: "Warranty Status", selector: row => row.Warranty_Status, sortable: true, wrap: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Company", selector: row => row.Company, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        { name: "Ticket Stages", selector: row => row.Ticket_Stages, sortable: true, wrap: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Lead Status", selector: row => row.Lead_Status, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // // { name: "Annual Revenue", selector: row => row.Annual_Revenue, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // // { name: "Payment Type", selector: row => row.Payment_Type1, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Lead Quality", selector: row => row.Lead_Quality, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Street", selector: row => row.Street, sortable: true, wrap: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "State", selector: row => row.State, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Pin Code", selector: row => row.Pin_Code, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // // { name: "Country", selector: row => row.Country, sortable: true, style: { fontSize: 16, color: "#5A5A5C" } },
        // { name: "Created Time", selector: row => new Date(row.Created_Time).toLocaleString(), sortable: true, wrap: true, style: { fontSize: 16, color: "#5A5A5C" } },


    ];







    const [selectedColumns, setSelectedColumns] = useState([]);

    const [remarksError, setRemarksError] = useState("");
    // State to track the most recently clicked column
    const [lastClickedColumn, setLastClickedColumn] = useState(null);
    const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state


    // Fetch columns from localStorage or default columns when component mounts
    useEffect(() => {
        const storedColumns = localStorage.getItem("selectedColumnsLeads");

        if (storedColumns) {
            // If columns are found in localStorage, use them
            const parsedColumns = JSON.parse(storedColumns);
            setSelectedColumns(parsedColumns);
            setInitialColumns(parsedColumns); // Save the initial state
        } else {
            // Otherwise, use default columns (this is assuming 'columns' is your default set)
            const defaultColumns = columns.map(col => col.name);
            setSelectedColumns(defaultColumns);
            setInitialColumns(defaultColumns); // Save the initial state
        }
    }, []);
    // const [error, setError] = useState(false);






    // const currentPage = page || 1;
    //    const currentPage = page || 1;






    const formatDateForBackend = (dateInput) => {
        if (!dateInput) return "";

        const date = new Date(dateInput);

        const pad = (n) => n.toString().padStart(2, "0");

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const offset = -date.getTimezoneOffset(); // Note the sign flip
        const sign = offset >= 0 ? "+" : "-";
        const absOffset = Math.abs(offset);
        const offsetHours = pad(Math.floor(absOffset / 60));
        const offsetMinutes = pad(absOffset % 60);

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
    };















    const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
    const [donationOptions, setDonationOptions] = useState([]);
    const [callDispositionPicklistOptions, setCallDispositionPicklistOptions] = useState([]);



    // useEffect(() => {
    //     fetchContacts();
    // }, [searchValues.page, searchValues.limit, dealerDetail?.Email]);

    const [rescheduleDateTime, setRescheduleDateTime] = useState("");
    const [donationPurpose, setDonationPurpose] = useState("");
    const [callDisposition, setCallDisposition] = useState("");


    const fetchBirthdayLeadsFetcher = async (url, body) => {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Failed to fetch birthday leads");

        const birthdayData = await res.json();

        if (birthdayData.status !== "success") return [];

        const seen = JSON.parse(localStorage.getItem("seenBirthdayLeads") || "[]");

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const leadsWithBirthdayInfo = (birthdayData.data || []).map((lead) => {
            const dob = new Date(lead.Date_of_Birth);
            const thisYearBirthday = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());
            thisYearBirthday.setHours(0, 0, 0, 0);

            let daysUntilBirthday = null;
            if (thisYearBirthday.getTime() === today.getTime()) {
                daysUntilBirthday = 0;
            } else if (thisYearBirthday.getTime() === tomorrow.getTime()) {
                daysUntilBirthday = 1;
            }

            return { ...lead, daysUntilBirthday };
        }).filter(lead =>
            (lead.daysUntilBirthday === 0 || lead.daysUntilBirthday === 1) &&
            !seen.includes(lead.id)
        );

        // 🔽 Sort: today (0) first, then tomorrow (1)
        leadsWithBirthdayInfo.sort((a, b) => a.daysUntilBirthday - b.daysUntilBirthday);

        return leadsWithBirthdayInfo;
    };


    const key = dealerDetail?.Email
        ? `/server/dealer_backend/getLeadsBirthdays?dealerEmail=${dealerDetail.Email}`
        : null; // skip fetch if no email

    // Only fetch once (on mount) by disabling revalidation
    const { data: birthdayLeads } = useSWR(
        key,
        (url, body) => fetchBirthdayLeadsFetcher(url, body),
        {
            revalidateOnFocus: false,  // don't refetch when window gets focus
            revalidateOnReconnect: false, // don't refetch on network reconnect
            revalidateIfStale: false, // don't refetch if cache is stale
            shouldRetryOnError: false, // optional: don't retry automatically
        }
    );










    // console.log({ leads })



    const location = useLocation();

    // Lead Source (restore from localStorage if exists)
    const [selectedLeadSource, setSelectedLeadSource] = useState(() => {
        return localStorage.getItem("leadSource") || "";
    });

    // List Name (selectedCampaign) - restore from localStorage ONLY if leadSource allows it
    const [selectedCampaign, setSelectedCampaign] = useState(() => {
        const savedLeadSource = localStorage.getItem("leadSource") || "";

        return localStorage.getItem("listName") || "";
    });

    // Call Disposition (restore only if leadSource allows it)
    const [selectedCallDisposition, setSelectedCallDisposition] = useState(() => {
        const savedLeadSource = localStorage.getItem("leadSource") || "";
        const savedCallDisposition = localStorage.getItem("callDisposition") || "";

        return savedCallDisposition;
    });

    // Donor Name (always restore if exists)
    const [donorNameFilter, setDonorNameFilter] = useState(() => {
        return localStorage.getItem("donorNameFilter") || "";
    });

    // Reset callDisposition, selectedCampaign when leadSource changes to Face to Face/All/""




    const fetcher2 = url => fetch(url).then(res => res.json());

    const dealerEmail = dealerDetail?.Email || '';

    // const keySecond = dealerEmail ? `/server/dealer_backend/getALead?dealerEmail=${dealerEmail}` : null;

    // const { data } = useSWR(
    //     keySecond,
    //     fetcher2,
    //     {
    //         revalidateOnFocus: false,     // don't refetch when window gains focus
    //         revalidateOnReconnect: false, // don't refetch on network reconnect
    //         revalidateIfStale: false,     // don't refetch if cache is stale
    //         shouldRetryOnError: false,    // optional: don't retry on error
    //     }
    // );

    // // Extract unique campaign options once data is loaded and status is success
    // const campaignOptions = data?.status === "success"
    //     ? [...new Set(data.data.map(item => item.List_Name).filter(Boolean))]
    //     : [];







    // custom fetcher for POST
    const postFetcher = async (url, body) => {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            const error = new Error("Error fetching leads");
            error.status = res.status;
            throw error;
        }
        return res.json();
    };

    function useLeads(params) {
        // If params is falsy, set key to null to skip fetching (SWR convention)
        const key = params
            ? ["/server/dealer_backend/getAllLeads", params]
            : null;

        const { data, error, isLoading } = useSWR(
            key,
            ([url, body]) => postFetcher(url, body),
            {
                revalidateOnFocus: false,
                keepPreviousData: true,
            }
        );
        // filter leads by layout.id
        const filteredLeads = data?.data.filter(lead => lead.Layout?.id === "362892000000000167");

        console.log({ filteredLeads })

        return {
            leads: filteredLeads || [],
            pagination: data?.pagination || {},
            isLoading,
            totalRecords: data?.pagination?.totalRecords || 0,
            isError: error,
            refresh: () => mutate(key),
        };
    }



    const [alternatePhone, setAlternatePhone] = useState(lead?.Alternate_Mobile || "");
    const [callRemarks, setCallRemarks] = useState("");
    const [donorInterest, setDonorInterest] = useState("");
    const [callStatus, setCallStatus] = useState("");
    const [email, setEmail] = useState(lead?.Email || "");
    const [phone, setPhone] = useState(lead?.Mobile || "");
    const [subDisposition, setSubDisposition] = useState("");
    const interestedOptions = [
        "Donated on the spot",
        "Will donate later",
        "Asked for donation link",
        "Need more information/followup"
    ];

    const notInterestedOptions = [
        "Already supporting",
        "Financial constraints",
        "Avoided conversation",
        "No reason given"
    ];






    const handleSubmit = async () => {
        let isValid = true;
        setEmailError("");
        setPhoneError("");
        setAlternatePhoneError("");
        setIsSubmitting(true); // Start loading state

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/;

        if (email && !emailRegex.test(email)) {
            const msg = "Please enter a valid email address.";
            setEmailError(msg);
            toast.error(msg);
            isValid = false;
        }


        if (phone && !phoneRegex.test(phone)) {
            const msg = "Phone must be a 10-digit number.";
            setPhoneError(msg);
            toast.error(msg);
            isValid = false;
        }

        if (alternatePhone && !phoneRegex.test(alternatePhone)) {
            const msg = "Alternate phone must be a 10-digit number.";
            setAlternatePhoneError(msg);
            toast.error(msg);
            isValid = false;
        }

        if (callStatus === "Reschedule" && isNaN(new Date(rescheduleDateTime))) {
            toast.error("Please select a valid reschedule date and time.");
            isValid = false;
        }

        if (callDisposition === "Call back" && isNaN(new Date(rescheduleDateTime))) {
            toast.error("Please select a valid reschedule date and time.");
            isValid = false;
        }

        if (callDisposition === "Hot lead" && isNaN(new Date(rescheduleDateTime))) {
            toast.error("Please select a valid reschedule date and time.");
            isValid = false;
        }

        if (!callRemarks || callRemarks.trim() === "") {
            const msg = "Remarks are required.";
            setRemarksError(msg);
            isValid = false;
        }


        if (!isValid) {
            setIsSubmitting(false); // Re-enable button
            return;
        }

        // ✅ Find the selected catalyst user from the list


        const callPayload = {
            data: [
                {
                    Related_record_of_new_donor: {
                        id: lead?.id,
                        name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
                    },
                    Name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
                    Email: lead?.Email,
                    Mobile_Number: lead?.Mobile,
                    Alternate_Mobile: alternatePhone,
                    Remarks: callRemarks,
                    Donor_Interest: donorInterest,
                    Purpose1: donationPurpose,
                    Call_Status: callStatus,
                    Call_Type: "outbound",
                    Sub_Disposition: subDisposition,
                    Reschedule_Time:
                        (callStatus === "Reschedule" || callDisposition === "Call back" || callDisposition === "Hot lead") && rescheduleDateTime
                            ? formatDateForBackend(rescheduleDateTime)
                            : null,


                    Catalyst_User: lead?.Catalyst_User ? lead?.Catalyst_User?.id : null,

                    // Catalyst_User_Email: selectedCatalystUser?.Email || "",
                    Catalyst_User_Email: lead?.Catalyst_User_Email || "",
                },
            ],
        };

        // Additional PUT request to update lead fields
        const leadUpdatePayload = {
            data: [
                {
                    Donor_Interest: callStatus,
                    Sub_Disposition: subDisposition,
                    // Purpose1: donationPurpose,
                    Call_Dispositions: callDisposition,
                    // or use another variable if you separate remarks from purpose
                },
            ],
        };

        try {
            const leadUpdateRes = await fetch(`/server/dealer_backend/edit-leadDetails/${lead?.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(leadUpdatePayload),
            });

            const leadUpdateResult = await leadUpdateRes.json();

            if (!leadUpdateRes.ok || leadUpdateResult.status !== "success") {
                // console.error("Lead update failed:", leadUpdateResult);
                toast.error("Failed to update donor fields.");
                return;
            }

            // toast.success("Call Log Created successfully!");
            // return true;
        } catch (error) {
            // console.error("Error updating lead fields:", error);
            toast.error("An unexpected error occurred while updating lead details.");
        }


        try {
            const callRes = await fetch("/server/dealer_backend/handleCalls", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(callPayload),
            });

            const callResult = await callRes.json();

            if (!callRes.ok || callResult.status !== "success") {
                // console.error("Call creation failed:", callResult);
                toast.error("Failed to create call log.");
                return;
            }

            toast.success("Call log created successfully!");
            await refresh();
            return true;
        } catch (error) {
            // console.error("Error submitting form:", error);
            toast.error("An unexpected error occurred.");
        } finally {
            setIsSubmitting(false); // ✅ only reset the state here
        }
    };


    useEffect(() => {
        if (isWidgetModalOpen) {
            // Reset all form fields when modal opens
            setEmail(lead?.Email || "");
            setPhone(lead?.Mobile || "");
            setAlternatePhone(lead?.Phone_2 || "");
            setCallRemarks("");
            setDonationPurpose(lead?.Purpose1 || "");
            setCallStatus(lead.Donor_Interest || "");
            setCallDisposition(lead.Call_Dispositions || "");
            setSubDisposition(lead?.Sub_Disposition || "");
            setRescheduleDateTime("");
            setEmailError("");
            setPhoneError("");
            setAlternatePhoneError("");
            setError(false);
            setIsSubmitting(false);
        }
    }, [isWidgetModalOpen, lead]);


    // ✅ "Applied" filters — what actually gets sent to API
    const [appliedFilters, setAppliedFilters] = useState({
        selectedLeadSource: "",
        selectedCallDisposition: "",
        selectedCampaign: "",
        donorNameFilter: "",

    });

    console.log({dealerDetail});
    // Hook fetches using "appliedFilters"
    const { leads, pagination, totalRecords, isLoading, isError, refresh } = useLeads({
        page: searchValues.page,
        limit: searchValues.limit,
        dealerEmail: dealerDetail?.Email,
        ...appliedFilters,
    });

    //   console.log({totalRecords})
    // ✅ Apply button handler
    const handleApplyFilters = () => {
        setAppliedFilters({
            selectedLeadSource,
            selectedCallDisposition,
            selectedCampaign,
            donorNameFilter,
        });
        setSearchValues((prev) => ({ ...prev, page: 1 })); // Reset page
    };




    // ✅ Clear button handler
    const handleClearFilters = () => {
        setSelectedLeadSource("");
        setSelectedCallDisposition("");
        setSelectedCampaign("");
        setDonorNameFilter("");

        setAppliedFilters({
            selectedLeadSource: "",
            selectedCallDisposition: "",
            selectedCampaign: "",
            donorNameFilter: "",
        });
        setSearchValues({ page: 1, limit: searchValues.limit });
    };


    useEffect(() => {
        const savedLeadSource = localStorage.getItem("leadSource") || "";
        const savedCallDisposition = localStorage.getItem("callDisposition") || "";
        const savedCampaign = localStorage.getItem("listName") || "";
        const savedDonorName = localStorage.getItem("donorNameFilter") || "";

        setSelectedLeadSource(savedLeadSource);
        setSelectedCallDisposition(savedCallDisposition);
        setSelectedCampaign(savedCampaign);
        setDonorNameFilter(savedDonorName);

        // Initialize appliedFilters to restored filter values
        setAppliedFilters({
            selectedLeadSource: savedLeadSource,
            selectedCallDisposition: savedCallDisposition,
            selectedCampaign: savedCampaign,
            donorNameFilter: savedDonorName,
        });
    }, []);






    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchValues((prev) => ({
            ...prev,
            page: newPage
        }));
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };
    const [showBirthdayDropdown, setShowBirthdayDropdown] = useState(false);
    // const [birthdayLeads, setBirthdayLeads] = useState([]);

    const getDaysUntilBirthday = (dobStr) => {
        if (!dobStr) return null;

        const today = new Date();
        const dob = new Date(dobStr);
        const nextBirthday = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

        // If the birthday this year already passed, go to next year
        if (
            nextBirthday.getMonth() === today.getMonth() &&
            nextBirthday.getDate() === today.getDate()
        ) {
            return 0; // 🎂 TODAY!
        }

        if (nextBirthday < today) {
            nextBirthday.setFullYear(today.getFullYear() + 1);
        }

        const diffTime = nextBirthday - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, [breakpoint]);

        return isMobile;
    }





    function MobileDonorCard({
        donor,
        serialNo,
        setSelectedRow,
        setLead,
        setPhone,
        setEmail,
        setAlternatePhone,
        setCallRemarks,
        setDonationPurpose,
        setSubDisposition,
        setCallStatus,
        setCallDisposition,
        setIsWidgetModalOpen,
    }) {
        const handleCreateLog = (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Sync donor into all state
            setLead(donor);
            setEmail(donor.Email || "");
            setPhone(donor.Mobile || "");
            setAlternatePhone(donor.Phone_2 || "");
            setCallRemarks("");
            setDonationPurpose(donor.Purpose1 || "");
            setSubDisposition(donor?.Sub_Disposition);
            setCallStatus(donor.Donor_Interest || "");
            setCallDisposition(donor.Call_Dispositions || "");
            setIsWidgetModalOpen(true);
        };

        return (
            <Link to={`/owner-details/${donor.id}`}>
                <div
                    className="mobile-card ml-[-24px]
          bg-white 
          shadow 
          rounded-xl 
          p-4 
          mb-4 
          w-[110%] 
          max-w-md 
          hover:bg-gray-50 
          transition 
          cursor-pointer"
                >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-2">
                        {/* Left side */}
                        <div className="flex items-center gap-3">
                            <div
                                className="
                w-10 
                h-10 
                rounded-full 
                bg-blue-100 
                flex 
                items-center 
                justify-center 
                text-blue-600 
                font-bold 
                text-lg"
                            >
                                {serialNo || "1"}
                            </div>
                            <div>
                                <p className="font-semibold text-gray-900">
                                    {`${donor.First_Name || ""} ${donor.Last_Name || ""}`.trim()}
                                </p>
                                <p className="text-xs text-gray-500">{donor.id}</p>
                            </div>
                        </div>

                        {/* Right side */}
                        <div className="flex flex-col items-start sm:items-end gap-2">
                            <span
                                className="
                text-xs 
                bg-green-100 
                text-green-700 
                px-3 
                py-1 
                rounded-full 
                font-semibold
                whitespace-nowrap"
                            >
                                {donor.IFR_Lead_Sources || ""}
                            </span>
                            <button
                                onClick={handleCreateLog}
                                className="
                bg-blue-600 
                text-white 
                text-xs 
                px-3 
                py-1 
                rounded 
                hover:bg-blue-700 
                transition"
                            >
                                Create Log
                            </button>
                        </div>
                    </div>

                    <hr className="my-2" />

                    <div className="text-sm text-gray-700 space-y-1">
                        <div className="flex justify-between">
                            <span className="text-gray-500">List Name</span>
                            <span className="text-right">{donor.Campaign_Name || "N/A"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-500">Last Donation Amount</span>
                            <span className="text-right">{donor.Last_Donation_Amount || "N/A"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-500">Last Donation Date</span>
                            <span className="text-right">{donor.Last_Donation_Date || "N/A"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-500">Purpose</span>
                            <span className="text-right">{donor.Purpose1 || "N/A"}</span>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }







    // const [totalRecords, setTotalRecords] = useState(0);





    const isMobile = useIsMobile();




    const [loading, setLoading] = useState(true);






    useEffect(() => {
        setRowsPerPage(searchValues.limit);
        setCurrentPage(searchValues.page);
    }, [searchValues]);








    // useEffect(() => {
    //     fetchContacts({
    //         page: currentPage,
    //         limit: rowsPerPage,
    //         filters: {
    //             // any filters like disposition, campaign, etc.
    //         }
    //     });
    // }, [currentPage, rowsPerPage, selectedDisposition, selectedCampaignName, debouncedEmailFilter, debouncedPhoneFilter, debouncedDonorNameFilter]);


    const OFFSET = (searchValues.page - 1) * searchValues.limit;
    // Function to apply filters (save to localStorage)
    const applyFilter = () => {
        try {
            // Ensure only primitive values (strings) are stored
            const safeColumns = selectedColumns.map(col => String(col));
            localStorage.setItem("selectedColumnsLeads", JSON.stringify(safeColumns));
        } catch (error) {
            // console.error("Error saving to localStorage:", error);
        }

        setIsModalOpen(false);
    };

    const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state



    // Function to reset filter by restoring the saved state
    const resetFilter = () => {
        setSelectedColumns(prevSelectedColumns); // Restore previous selection
        setIsModalOpen(false);
    };

    // Function to handle column changes
    const handleColumnChange = (colName) => {
        setSelectedColumns((prev) => {
            const updatedColumns = prev.includes(colName)
                ? prev.filter((name) => name !== colName)
                : [...prev, colName];

            try {
                // Ensure only primitive values (strings) are stored
                const safeColumns = updatedColumns.map(col => String(col));
                localStorage.setItem("selectedColumnsLeads", JSON.stringify(safeColumns));
            } catch (error) {
                // console.error("Error saving to localStorage:", error);
            }

            // Track the most recent checkbox clicked
            setLastClickedColumn(colName);

            return updatedColumns;
        });
    };

    const filteredColumns = columns.filter(
        col => selectedColumns.includes(col.name) || typeof col.name === "object"
    );


    return (
        <div className="p-4 space-y-6">


            <div className="flex items-center justify-between w-full">
                {/* Left Side: Manage Columns Button */}
                {/* <div className="flex items-center gap-4">
                    <button
                        onClick={openModal}
                        aria-label="Manage columns"
                        className="hidden md:flex items-center gap-2 px-3 py-2 bg-white shadow rounded-md hover:text-[#2070B9] transition text-[#2070B9]"
                        type="button"
                    >
                        <TfiMenuAlt className="text-lg" />
                    </button>
                </div> */}

                {/* Right Side: Cake Button + Add Lead Button */}
                <div className="flex items-center gap-6 ml-auto">


                    <button
                        type="button"
                        onClick={() => navigate("/create-ticket")}
                        className="bg-[#003967] text-white px-4 py-2 rounded-md hover:bg-[#040E18] focus:outline-none focus:ring-2 focus:ring-blue-400 shadow transition flex items-center gap-1"
                    >
                        
                        <span className="hidden sm:inline">Create Ticket</span>
                    </button>
                </div>
            </div>



            {/* Topbar: Birthday, Filters, Add Lead, Manage Columns */}
            <div className="rounded-md px-4 py-3 mb-4 flex flex-wrap items-end gap-4 ">

                {/* Lead Source Filter */}
                <div className="flex flex-col w-48">
                    <label
                        htmlFor="leadSource"
                        className="text-gray-800 text-sm font-medium mb-1"
                    >
                        Status of Ticket
                    </label>
                    <select
                        id="leadSource"
                        className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 transition bg-white"
                        value={selectedLeadSource}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            setSelectedLeadSource(newValue);
                            setCurrentPage(1);

                            const shouldHideCD =
                                newValue === "" || newValue === "Face to Face" || newValue === "All";
                            if (shouldHideCD) {
                                setSelectedCallDisposition("");
                                localStorage.removeItem("callDisposition");
                                setSelectedCampaign("");
                                localStorage.removeItem("campaignName");
                            }
                        }}
                    >
                        <option value="">All</option>
                        {leadSourceOptions.map((opt, idx) => (
                            <option key={idx} value={opt.value || opt}>
                                {opt.display_value || opt}
                            </option>
                        ))}
                    </select>
                </div>
                

                {/* Conditional Call Disposition + Campaign */}

                {/* <div className="flex flex-col w-48">
                                <label
                                    htmlFor="callDisposition"
                                    className="text-gray-800 text-sm font-medium mb-1"
                                >
                                    Lead Type
                                </label>
                                <select
                                    id="callDisposition"
                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 transition bg-white"
                                    value={selectedCallDisposition}
                                    onChange={(e) => {
                                        setSelectedCallDisposition(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value="">All</option>
                                    {callDispositionOptions.map((opt, idx) => (
                                        <option key={idx} value={opt.value || opt}>
                                            {opt.display_value || opt}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex flex-col w-48">
                                <label
                                    htmlFor="campaign"
                                    className="text-gray-800 text-sm font-medium mb-1"
                                >
                                   Lead Status
                                </label>
                                <select
                                    id="campaign"
                                    className="border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 transition bg-white"
                                    value={selectedCampaign}
                                    onChange={(e) => {
                                        setSelectedCampaign(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value="">All</option>
                                    {leadStatusOptions.map((name) => (
                                        <option key={name} value={name}>
                                            {name}
                                        </option>
                                    ))}
                                </select>
                            </div> */}




                {/* ✅ Action Buttons aligned right */}
                <div className="flex gap-3 ml-auto mt-6 sm:mt-0">
                    <button
                        type="button"
                        onClick={handleClearFilters}
                        className="bg-[#F3F4F6] hover:bg-[#C0DCF3] text-gray-700 font-medium px-4 py-1.5 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#C0DCF3] focus:ring-offset-1 border border-[#003967] transition"
                    >
                        Clear Filters
                    </button>

                    <button
                        type="button"
                        onClick={handleApplyFilters}
                        className="bg-[#F3F4F6] hover:bg-[#C0DCF3] text-gray-700 font-medium px-4 py-1.5 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#C0DCF3] focus:ring-offset-1 border border-[#003967] transition"
                    >
                        Apply Filters
                    </button>
                </div>
            </div>






            {/* Data Table Area */}
            <div>
                {/* Conditional render loading */}
                {isLoading ? (
                    <div className="flex justify-center items-center gap-2 py-10 text-blue-600">
                        <svg
                            className="animate-spin h-6 w-6 text-blue-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        Loading Data...
                    </div>
                ) : leads?.length === 0 ? (
                    <div className="text-center py-10 text-blue-600 font-medium text-lg">No data found</div>
                ) : isMobile ? (
                    <div className="space-y-4 px-2">
                        {leads.map((donor, i) => (
                            <MobileDonorCard
                                key={i}
                                serialNo={(currentPage - 1) * rowsPerPage + i + 1}
                                donor={donor}
                                setSelectedRow={setSelectedRow}
                                setLead={setLead}
                                setPhone={setPhone}
                                setEmail={setEmail}
                                setAlternatePhone={setAlternatePhone}
                                setCallRemarks={setCallRemarks}
                                setDonationPurpose={setDonationPurpose}
                                setSubDisposition={setSubDisposition}
                                setCallStatus={setCallStatus}
                                setCallDisposition={setCallDisposition}
                                setIsWidgetModalOpen={setIsWidgetModalOpen}
                            />

                        ))}
                    </div>
                ) : (
                    <>
                        {/* DataTable Wrapper */}
                        <div className="relative rounded-xl shadow border border-gray-200">

                            {/* Manage Columns Button - Positioned Top Right Overlay */}

                            <button
                                onClick={openModal}
                                aria-label="Manage columns"
                                className="hidden md:flex absolute top-3 right-3 items-center gap-2 px-3 py-2
    bg-white shadow mt-[-14.09px] mr-[-12px]  hover:text-[#2070B9] transition text-[#2070B9] z-10 border-l-2 border-black rounded-r-md"
                                type="button"
                            >
                                <TfiMenuAlt className="text-base" />
                            </button>

                            <span className="absolute top-[-35px] right-0 opacity-0 group-hover:opacity-100 transition bg-black text-white text-xs rounded px-2 py-1 shadow">
                                Manage Columns
                            </span>



                            {/* DataTable */}
                            <DataTable
                                columns={filteredColumns}
                                data={leads}
                                fixedHeader
                                dense
                                responsive
                                highlightOnHover
                                //  selectableRows
                                // theme="solarized"
                                // subHeaderAlign={Alignment.LEFT }
                                resizableColumns
                                progressPending={isLoading}
                                className="custom-table text-base "
                                onRowClicked={(row) => navigate(`/ticket-details/${row.id}`)}
                                customStyles={{
                                    headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                                    cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px", width: "250px" } },
                                    rows: {
                                        style: {
                                            transition: "background 0.2s",
                                            "&:hover": { background: "#ebf4ff" },
                                        },
                                    },
                                }}
                                style={FaBorderAll}
                            />

                        </div>


                        {/* Pagination + Rows per page */}
                        <div className="mt-4 flex flex-wrap justify-between items-center gap-4 px-2">
                            <div className="flex items-center text-gray-700 text-sm md:text-base">
                                <span className="font-medium mr-1">Showing</span>
                                <span className="px-2 py-1 bg-blue-100 text-blue-700 font-semibold rounded-lg">
                                    {`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                                        currentPage * rowsPerPage,
                                        totalRecords
                                    )}`}
                                </span>
                                <span className="ml-1">of {totalRecords} entries</span>
                            </div>

                            <div className="flex items-center gap-2">
                                <label htmlFor="recordsPerPage" className="text-gray-700 font-medium select-none">
                                    Records per page:
                                </label>
                                <select
                                    id="recordsPerPage"
                                    value={searchValues.limit}
                                    onChange={(e) =>
                                        setSearchValues((prev) => ({
                                            ...prev,
                                            limit: Number(e.target.value),
                                        }))
                                    }

                                    className="border border-gray-300 rounded px-2 py-1 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                >
                                    {[25, 50, 100, 200].map((n) => (
                                        <option key={n} value={n}>
                                            {n}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <Pagination
                                currentPage={currentPage}
                                totalPages={Math.ceil(totalRecords / rowsPerPage)}
                                onPageChange={onPageChange}
                            />
                        </div>
                    </>
                )}
            </div>


            {/* Manage Columns Modal */}
            {
                isModalOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
                        onClick={() => setIsModalOpen(false)}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="manage-columns-title"
                    >
                        <div
                            className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h2 id="manage-columns-title" className="text-xl font-bold mb-4">
                                Manage Columns
                            </h2>

                            <input
                                type="text"
                                placeholder="Search columns..."
                                className="w-full p-2 border border-gray-300 rounded mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                            <div className="max-h-60 overflow-auto border border-gray-200 rounded p-2">
                                {columns
                                    .filter(col => typeof col.name === "string")
                                    .filter(col => col.name.toLowerCase().includes(searchTerm.toLowerCase()))
                                    .map((col, index) => {
                                        const isLastName = col.name === "Last Name";
                                        return (
                                            <label key={index} className="flex items-center mb-2 cursor-pointer select-none">
                                                <input
                                                    type="checkbox"
                                                    className="mr-2"
                                                    checked={selectedColumns.includes(col.name)}
                                                    disabled={isLastName}
                                                    onChange={() => {
                                                        if (!isLastName) handleColumnChange(col.name);
                                                    }}
                                                />
                                                <span className={isLastName ? "text-gray-400" : ""}>{col.name}</span>
                                            </label>
                                        );
                                    })}
                            </div>

                            <div className="flex justify-end mt-6 gap-3">
                                <button
                                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
                                    onClick={resetFilter}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                                    onClick={applyFilter}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );

}
